import { createFileRoute } from "@tanstack/react-router";
import { supporters } from "@/data/supporters";
import { ProfilePage, profileHead, ProfileError } from "@/pages/ProfilePage";

const supporter = supporters.find((s) => s.id === "malene")!;

export const Route = createFileRoute("/en/meet-malene")({
  head: () => profileHead(supporter, "en"),
  errorComponent: ({ error }) => <ProfileError locale="en" error={error} />,
  component: () => <ProfilePage supporter={supporter} locale="en" />,
});
